app.controller("PositionsIndexController", [
    "$scope", "$uibModal", "SysParam", "StaticData", "ConfirmModal", "$stateParams", "usSpinnerService", "$state", "toastr", "DocumentsService", "OrganizationalUnit",
    function ($scope, $uibModal, SysParam, StaticData, ConfirmModal, $stateParams, usSpinnerService, $state, toastr, DocumentsService, OrganizationalUnit) {

        $scope.positions = [];
        $scope.unit = null;

        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.nameQuery = $stateParams.nameQuery;

        if ($stateParams.organization) {
            OrganizationalUnit.getById($stateParams.organization).then(function (data) {
                $scope.unit = data
            });
        }

        $scope.getUnits = function (query) {
            if (query.length < 2) {
                return [];
            }
            return OrganizationalUnit.findByQuery({ query: query }).then(function (data) {
                return data;
            });
        };

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                organization: $scope.unit ? $scope.unit._id : null,
                name: $scope.nameQuery
            });
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            DocumentsService.positionsList({
                page: page,
                limit: $scope.itemsPerPage,
                organization: $stateParams.organization,
                name: $stateParams.name
            }).then(function (data) {
                $scope.positions = data.docs;
                $scope.currentPage = $stateParams.page;
                usSpinnerService.stop("root");
                $scope.totalItems = data.total;

                staff.forEach(function (employee) {
                    if (!employee.user.photo) {
                        if (employee.user.gender) {
                            if (employee.user.gender === 'male') employee.user.photo = "img/male.jpg";
                            else employee.user.photo = "img/female.jpg";
                        }
                        else {
                            employee.user.photo = "img/no_image.jpg";
                        }
                    }
                });

                $scope.staff = staff;
                $scope.totalItems = data.total;
                cb();
            });
        }

        $scope.add = function () {
            $uibModal.open({
                controller: "EmployeeStaffAddController",
                templateUrl: _pb + 'employee/staff/employee-staff-add.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    toastr.success('', 'თანამშრომელი წარმატებით დაემატა');
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.edit = function (position, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "ManageRolesController",
                templateUrl: _pb + 'sudo/users/manage-roles.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: {
                        position: position,
                        type: 'DOCFLOW'
                    }
                }
            }).result
                .then(function (result) {
                    loadPage()
                }, function () {
                });
        };
    }
]);
